module.exports = __webpack_public_path__ + "static/media/todd-pic-250x250.941dc1d4.jpg";